import { render } from "./ExportToXls.vue?vue&type=template&id=63eef835"
import script from "./ExportToXls.vue?vue&type=script&lang=js"
export * from "./ExportToXls.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__